module.exports = __webpack_public_path__ + "img/Shelta-NDP2.6fd200d0.jpeg";